module.exports = __webpack_public_path__ + "img/trophee_on.61a336e7.gif";